import React from 'react';
import SEO from '../components/SEO';
import DiningHero from '../components/dining_hero';
import DiningOverview from '../components/DiningOverview';
import DiningGallery from '../components/dining_Gallary';
import OtherServices from '../components/OtherServices';

const DiningRestaurant = ({ language }) => {
  return (
    <>
      <SEO
        title="Dining Restaurant"
        description="Experience exceptional dining at Blue Nest Hotel's restaurant. Authentic Ethiopian and international cuisine."
        url="/dining"
      />
      <DiningHero language={language} />
      <DiningOverview language={language} />
      <DiningGallery language={language} />
      <OtherServices language={language} />
    </>
  );
};

export default DiningRestaurant;
